import Events from '@/scripts/lib/Events';

export default class SpinBtn {
   /** @param {HTMLButtonElement} btn */
   constructor(btn, { delay = 300, doneDelay = 2000, checkIcon = true } = {}) {
      this._btn = btn;

      this._delay = delay;
      this._doneDelay = doneDelay;
      this._checkIcon = checkIcon;

      this._timers = [];
      this._loading = false;

      this.events = new Events();
   }

   startLoading() {
      this._clear();
      this._loading = true;

      this._btn.classList.add('btn-spin__hide_content');
      this._btn.classList.add('btn-spin__spin');
      this._btn.disabled = true;

      this.events.emit('loading.change');
   }

   stopLoading(isSuccess = true) {
      return new Promise((resolve) => {
         if (!this._loading) return;

         let time = 0;

         if (this._checkIcon || !isSuccess) {
            const resCls = (isSuccess) ? 'btn-spin__check' : 'btn-spin__failed';
            this._btn.classList.add(resCls);
         }

         this._timers.push(setTimeout(() => {
            this._btn.classList.remove('btn-spin__spin');
            this._btn.disabled = false;
            this._loading = false;

            this.events.emit('loading.change');
         }, time += this._delay));

         this._timers.push(setTimeout(() => {
            this._btn.classList.add('btn-spin__result');
            resolve();
         }, time += (isSuccess && this._checkIcon) ? this._delay : 0));

         this._timers.push(setTimeout(() => {
            this._btn.classList.remove('btn-spin__result');
            this._btn.classList.remove('btn-spin__hide_content');
         }, time += (this._checkIcon || !isSuccess) ? this._doneDelay : 0));
      });
   }

   isLoading() {
      return this._loading;
   }

   _clear() {
      this._timers.forEach(t => clearTimeout(t));
      this._timers = [];

      this._btn.classList.remove('btn-spin__result');
      this._btn.classList.remove('btn-spin__failed');
      this._btn.classList.remove('btn-spin__check');
      this._btn.classList.remove('btn-spin__hide_content');
   }
} 